import {
  ExecutePaymentRequestModel,
  PaymentMethod,
  PaymentStatus,
  PaymentURLModel,
} from "../../../domain/model/Payment";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { PaymentRepository } from "./PaymentRepository";

export class PaymentRepositoryImpl implements PaymentRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  initiatePayment(
    invoiceAmount: number
  ): Promise<Response<Array<PaymentMethod>>> {
    return this.apiService.initiatePayment(invoiceAmount);
  }
  executePayment(
    model: ExecutePaymentRequestModel
  ): Promise<Response<PaymentURLModel>> {
    return this.apiService.executePayment(model);
  }
  getPaymentStatus(paymentId: string): Promise<Response<PaymentStatus>> {
    return this.apiService.getPaymentStatus(paymentId);
  }
}
